import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import DownloadPage from './pages/DownloadPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';
import LegalNotice from './pages/LegalNotice';
import CookieNotice from './components/CookieNotice';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <Router>
      <CartProvider>
        <div className="flex flex-col min-h-screen bg-dark-900">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/product/winmax-custom-duration" element={<ProductPage />} />
              <Route path="/download" element={<DownloadPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/legal-notice" element={<LegalNotice />} />
            </Routes>
          </main>
          <Footer />
          <CookieNotice />
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;